module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"step":"список вопросов для интервью","back":"Назад","next":"Далее","special":"Давайте спросим несколько вопросов по специальности","select":"Выберите специальность или найдите вопрос по ключевому слову"}}')
  delete Component.options._Ctor
}
